/* eslint-disable */
<template>
<div width="90%">
  <h3 style="text-align:center">51Talk试听课用户调研</h3>
  <div>
    恭喜您已经为孩子的未来迈出了重要的一小步，为了在<strong style="color:orange">51Talk的试听课</strong>以及后期的学习中,根据宝贝的特征提供个性化的老师匹配和学习规划，需要您如实填写孩子的相关信息，您的数据我们会<strong>高度保密</strong>，感谢您对51alk的关注和支持!
  </div>
  <div class="breakline"></div>


  <div v-for="(ques, index) in questions" v-bind:key="index" class="flex-row">
    <div class="flex ques_header"><span class="ques_order">{{index+1}}</span></div>
    <div style="width: 100%">
      <question :question="ques" v-on:setAnswer="getAnswer" :id="ques.id"></question>
    </div>
  </div>

  <div style="text-align:center; margin-top: 10px; color:orange">
    <button @click="submit" class="feedback" :disabled="!isCompleteAnswer">提交</button>
  </div>
  <!-- <lessonDialog title="温馨提示" :content="content" :is-show="isShow" @confirm="confirm"></lessonDialog> -->
</div>
</template>

<script>
require('@/assets/css/common-flex.css')
require('@/assets/css/feedback.css')
import lessonDialog from '@/components/template/dialog/index.vue';
import Question from '@/components/template/question/Question'

export default {
  name: 'FT_Invest',
  components: {Question},
  data () {
    return {
      questions: [
        {
          id: 1,
          ques_type: 1,
          body: '您家宝宝性别? *',
          option: ['男', '女']},
        {
          id: 2,
          ques_type: 1,
          body: '您孩子现在几年级? *',
          option:['未上幼儿园','幼儿园小班','幼儿园中班','幼儿园大班','一年级','二年级','三年级','四年级','五年级','六年级','初中','高中','其他']
        }, // slider
        {
          id: 3,
          ques_type: 1,
          body: '孩子在校期间英语平均考试成绩是? *',
          option: ['还没考试过', '优秀(90-100)', '良好(80-90)', '中等(70-80)', '中下(60-70)', '不及格(<60)']
        },
        {
          id: 4,
          ques_type: 2,
          body: '孩子所接触的英文环境是？ * (多选)',
          option: ['零基础：从未接触过英语','在家里做过英语启蒙(听儿歌/读绘本/看动画等)','有固定的外国朋友交流','偶尔出国旅游接触英语','上过线下英语培训班','上过线上英语培训班','在国际(双语)学校学习英语','在公立学校学习英语']
        },
        {
          id: 5,
          ques_type: 1,
          body: '孩子英语学习了几年? *',
          option: ['0','1','2','3年及以上']
        },
        {
          id: 6,
          ques_type: 1,
          body: '孩子当前英语学习目的是? *',
          option: ['出国留学','应试提高英语分数','提升英语听说能力','提升英语阅读能力','提升自然拼读能力','只是兴趣引导，启蒙英语阶段','不知道']
        },
        {
          id: 7,
          ques_type: 1,
          body: '孩子当前的英语口语水平是? *',
          option: ['完全零基础','学过不会说','可以简单的交流','可以流利的交流']
        },
        {
          id: 8,
          ques_type: 1,
          body: '孩子是否接触过全英文的外教授课? *',
          option: ['是','否']
        },
        {
          id: 9,
          ques_type: 1,
          body: '您是否会陪伴孩子上试听课? *',
          option: ['是','否','不确定']
        },
        {
          id: 10,
          ques_type: 1,
          body: '孩子是否理解简单的英文课堂用语? *',
          option: ['是','否','不确定']
        },
        {
          id: 11,
          ques_type: 1,
          body: '您是否希望老师会部分中文? *',
          option: ['是','否','无所谓']
        },
        {
          id: 12,
          ques_type: 1,
          body: '您/孩子偏好的外教老师性别是? *',
          option: ['男','女','无所谓']
        },
        {
          id: 13,
          ques_type: 2,
          body: '您偏好的外教老师标签是?（多选最多3项) *',
          option: ['课堂气氛活跃','幽默健谈','和蔼可亲','热情','学习鼓励师','语速适中','善于纠错','发音标准','拓展丰富','肢体语言丰富','时间把控好','讲课个性化','举例达人']
        },
        {
          id: 14,
          ques_type: 1,
          body: '您的英语水平如何? *',
          option: ['完全零基础','学过不会说','会简单交流','可以流利交流']
        },
      ],
      answers: {},
      answers_user: {},
      // isShow: false,
      content: '感谢您的耐心填写，快去预约体验课吧！',
      isCompleteAnswer: false
    }
  },
  methods: {
    getAnswer: function (qid, ans) {
      this.answers[qid] = ans
      this.checkAnswer()
    },
    submit: function () {
      // console.table(this.answers)
      var uid = this.$route.query.uid
      this.answers_user['uid'] = uid
      this.answers_user['answer'] =  this.answers
      // console.log(this.answers_user)
      $.ajax({
          type: "post",
          url: "http://10.0.2.70:8124/api/cms_application/ft_question_user_answer",  //提交到70测试的api
          dataType: "json",//返回的数据类型格式 JSON.stringify(
          data: JSON.stringify(this.answers_user),
          success: function(ret){  //成功的时候返回的是数据，错误的时候数据为空
            if (ret.error_code === 0){  //修改成功 msg.success
              console.log('数据准确')
            }else {  //修改失败
              console.log('数据出错了')
            }
          }
      })
      alert('感谢您的耐心填写，快去预约体验课吧！');
      // history.back(); //返回到上一页
    },
    checkAnswer: function () {
      for (let i = 0; i < this.questions.length; i++) {
        let qid = this.questions[i].id
        let ans = this.answers[qid]
        //需用户答完提交，如若无需答完，答某一些部分就可以提交，这部分if可注释
        if (ans === undefined || ans === null || ans === '' || ans.length === 0) {
          console.log('Question ' + qid + ' is not answered!')
          this.isCompleteAnswer = false
          return
        }
      }
      this.isCompleteAnswer = true
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ques_order{
  height:20px;
  line-height:20px;
  display:block; color:#FFF;
  text-align:center;
  font-size:12px;
}
</style>



// WEBPACK FOOTER //
// src/components/FT_Invest.vue